
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Mail } from 'lucide-react';

interface EmailFieldProps {
  email: string;
  setEmail: (email: string) => void;
  error?: string;
}

const EmailField = ({ email, setEmail, error }: EmailFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="email">
        Email <span className="text-red-500">*</span>
      </Label>
      <div className="relative">
        <Mail className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
        <Input
          id="email"
          type="email"
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={`pl-10 ${error ? 'border-red-500' : ''}`}
        />
      </div>
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

export default EmailField;
